import { render, staticRenderFns } from "./ChatHeaderExpanded.vue?vue&type=template&id=eb3a70ec&"
import script from "./ChatHeaderExpanded.vue?vue&type=script&lang=js&"
export * from "./ChatHeaderExpanded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports